<template>
  <div class="text-ontick-carbon-900 px-6 py-6 dark:text-gray-300">
    <div class="pb-6">
      <h2 class="text-3xl font-semibold">Assinaturas</h2>
      <p class="text-sm">
        Acompanhe as cobranças de seus produtos e estratégias contratadas
      </p>
    </div>
    <div v-if="data.length > 0" class="hidden overflow-x-auto md:block">
      <div class="py-2">
        <div class="overflow-hidden rounded-lg shadow">
          <table
            class="divide-ontick-steel-300 dark:divide-ontick-graphite-500 min-w-full divide-y"
          >
            <thead class="bg-ontick-steel-200 dark:bg-ontick-steel-500">
              <tr>
                <th
                  v-for="(item, index) in header"
                  :key="index"
                  class="text-ontick-carbon-900 px-6 py-3 text-sm font-bold leading-4 dark:text-gray-300"
                >
                  {{ item }}
                </th>

                <th class="px-6 py-3">
                  <span class="sr-only">Ação</span>
                </th>
              </tr>
            </thead>
            <tbody
              class="divide-ontick-steel-300 dark:divide-ontick-steel-500 dark:bg-ontick-graphite-500 divide-y bg-gray-50"
            >
              <tr
                class="space-y-2 text-center"
                :class="item.license_status == 'ATIVA' ? ' ' : 'text-gray-500'"
                v-for="(item, index) in data"
                :key="index"
              >
                <td class="whitespace-no-wrap px-4 py-2 text-sm">
                  #{{ item.license_id }}
                </td>

                <td class="whitespace-no-wrap px-4 py-2 text-sm">
                  {{
                    item.product_name
                      ? item.product_name.replaceAll("_", " ")
                      : ""
                  }}
                </td>
                <td class="whitespace-no-wrap px-4 py-2 text-sm">
                  <span v-if="item.license_type === 'PRODUCT'">Produto</span>
                  <span v-else-if="item.license_type === 'PLAN'">Plano</span>
                  <span v-else>Extensão</span>
                </td>
                <td
                  :class="statusColor(item.license_status)"
                  class="whitespace-no-wrap px-4 py-2 text-sm"
                >
                  {{ item.license_status }}
                </td>
                <td class="whitespace-no-wrap px-4 py-2 text-sm">
                  {{ item.license_create_date }}
                </td>
                <td class="whitespace-no-wrap px-4 py-2 text-sm">
                  <span v-show="item.license_next_charge != '-'">{{
                    item.license_next_charge
                  }}</span>

                  <span v-show="item.license_next_charge == '-'"> -</span>
                </td>
                <td class="whitespace-no-wrap px-4 py-2 text-sm">
                  <span v-if="item.license_remaining_days === 1">
                    {{ item.license_remaining_days }} dia
                  </span>
                  <span v-else-if="item.license_remaining_days > 1">
                    {{ item.license_remaining_days }} dias
                  </span>
                  <span v-else> - </span>
                </td>

                <td
                  v-show="item.license_price == 0"
                  class="whitespace-no-wrap px-4 py-2 text-sm font-medium leading-5"
                >
                  Grátis
                </td>

                <td
                  v-show="item.license_price != 0"
                  class="whitespace-no-wrap px-4 py-2 text-sm font-medium leading-5"
                >
                  {{ item.license_price | currency }}
                </td>

                <td class="px-4 py-2 font-medium leading-5">
                  <ontick-switch-component
                    v-if="
                      item.license_type === 'EXTENSION' &&
                      item.license_status === 'ATIVA'
                    "
                    :active="item.active"
                    @switch="subscriptionAction(item)"
                  />
                  <span v-else>
                    <button
                      v-if="item.action"
                      class="text-ontick-blue-600 text-sm"
                      @click="subscriptionAction(item)"
                    >
                      {{ item.action }}
                    </button>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div
      v-if="data.length > 0"
      class="text-ontick-carbon-900 flex w-full flex-col overflow-hidden rounded-lg text-sm shadow-md dark:text-gray-300 md:hidden"
    >
      <div
        class="bg-ontick-steel-300 dark:bg-ontick-steel-500 grid w-full grid-cols-2"
      >
        <p class="th">Produto</p>
        <p class="th"><span class="sr-only">Detalhes</span></p>
      </div>
      <subscriptions-mobile-component
        :data="item"
        v-for="item in data"
        :key="item.license_id"
        @action="subscriptionAction($event)"
      />
    </div>
    <div v-show="data.length == 0 && !placeholder">
      <h1 class="py-20 text-center text-2xl font-semibold">
        Nenhuma assinatura encontrada
      </h1>
    </div>
    <placeholderTable v-show="data.length == 0 && placeholder" />
  </div>
</template>

<script>
import switchOntick from "@/app/shared/components/basic/ontick-switch.component.vue";
import placeholderTable from "@/app/shared/components/placeholder/placeholder-table.component.vue";
import OntickSwitchComponent from "../../../../shared/components/basic/ontick-switch.component.vue";
import { mapGetters, mapActions } from "vuex";
import SubscriptionsMobileComponent from "./subscriptions-mobile.component.vue";

export default {
  components: {
    switchOntick,
    placeholderTable,
    OntickSwitchComponent,
    SubscriptionsMobileComponent,
  },
  data() {
    return {
      data: [],
      percent: 10,
      active_modal: 0,
      sign_id: 0,
      placeholder: false,
      header: [
        "ID",
        "Produto",
        "Tipo",
        "Status",
        "Data de compra",
        "Próxima cobrança",
        "Tempo restante",
        "Preço",
      ],
    };
  },
  computed: {
    ...mapGetters({
      getSelectedAccount: "accountTypes/getSelectedAccount",
      getConfigs: "config/getConfigs",
    }),
  },
  methods: {
    ...mapActions({
      setUserConfig: "config/setUserConfig",
      fetchAccounts: "accountTypes/fetchAccounts",
    }),
    getConfig() {
      return new Promise((resolve, reject) => {
        this.$api
          .get(this.$endpoint.USER_CONFIGS)
          .then((response) => {
            this.setUserConfig(response.data);
            this.fetchAccounts(response.data.accounts);
            resolve();
          })
          .catch((error) => {
            if (error.data.status == "error") {
              this.setUserConfig(error.data);
            }
            reject();
          });
      });
    },
    subscriptionAction(item) {
      const actions = {
        Reativar: () => {
          this.$swal({
            title: "Reativar renovação automática",
            text: "Reative a renovação automática para não interromper a utilização desde serviço",
            confirmButtonText: "Confirmar",
            showLoaderOnConfirm: true,
            allowOutsideClick: () => !this.$swal.isLoading(),
            preConfirm: () => {
              return this.$api
                .post(`${this.$endpoint.BASE}${item.action_path}`, {
                  license_id: item.license_id,
                })
                .then((res) => {
                  return res;
                })
                .catch((err) => {
                  console.error(err);
                  this.$swal("Erro", "Ocorreu um erro", "error");
                });
            },
          }).then((modal) => {
            if (modal.isConfirmed) {
              this.listSubscriptions();
              this.$swal({
                title: "Sucesso",
                text: "Renovação automática reativada com sucesso",
                icon: "success",
                iconHtml: this.$icons.swal_success,
              });
            }
            this.getConfig();
          });
        },
        Ativar: () => {
          actions.Reativar();
        },
        Renovar: () => {
          this.$swal({
            title: "Renovar assinatura",
            text: "Renove sua assinatura e volte a utilizar este serviço. Será necessária confirmação de pagamento.",
            confirmButtonText: "Ir para pagamento",
          }).then((modal) => {
            if (modal.isConfirmed) {
              this.$api
                .post(`${this.$endpoint.BASE}${item.action_path}`, {
                  license_id: item.license_id,
                })
                .then((res) => {
                  const licenseTypes = {
                    PLAN: "plans",
                    PRODUCT: "product",
                    EXTENSION: "extensions",
                  };
                  this.$router.push({
                    name: "Pagamentos",
                    query: {
                      type: licenseTypes[item.license_type],
                      ...res.data,
                    },
                  });
                })
                .catch((err) => {
                  console.error(err);
                  this.$swal("Erro", err.data.msg, "error");
                });
            }
            this.getConfig();
          });
        },
        Desativar: () => {
          this.$swal({
            title: "Cancelar renovação automática",
            text: "Deseja realmente cancelar a renovação automática da assinatura?",
            showConfirmButton: false,
            showDenyButton: true,
            denyButtonText: "Cancelar assinatura",
            showLoaderOnDeny: true,
            allowOutsideClick: () => !this.$swal.isLoading(),
            preDeny: async () => {
              return this.$api
                .post(`${this.$endpoint.BASE}${item.action_path}`, {
                  license_id: item.license_id,
                })
                .then((res) => {
                  return res;
                })
                .catch((err) => {
                  console.error(err);
                  this.$swal("Erro", "Ocorreu um erro", "error");
                });
            },
          }).then((modal) => {
            if (modal.isDenied) {
              this.listSubscriptions();
              this.$swal({
                title: "Sucesso",
                text: "Renovação automática cancelada com sucesso",
                icon: "success",
                iconHtml: this.$icons.swal_success,
              });
            }
            this.getConfig();
          });
        },
        Verificar: () => {
          this.$swal({
            title: "Assinatura pendente",
            text: "Seu método de pagamento atual foi recusado pela Iugu. Entre em contato com nosso suporte.",
            confirmButtonEnabled: false,
          });
        },
      };
      actions[item.action]();
    },

    statusColor(status) {
      const colorList = {
        ATIVA: "text-ontick-green-500",
        CANCELADA: "text-ontick-red-500",
        PENDENTE: "text-ontick-yellow-500",
        EXPIRADA: "text-gray-500",
      };
      return colorList[status];
    },
    listSubscriptions() {
      this.placeholder = true;
      this.$api
        .get(this.$endpoint.GET_USER_SUBSCRIPTIONS)
        .then((res) => {
          this.data = res.data;
          for (let item of this.data) {
            item.active = item.action === "Desativar";
          }
        })
        .finally(() => {
          this.placeholder = false;
        });
    },
  },
  watch: {
    getConfigs: {
      immediate: true,
      deep: true,
      handler() {
        this.listSubscriptions();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.th {
  @apply px-4 py-2 text-center font-bold;
}
.td {
  @apply self-center px-4 py-2;
}
.modal-row {
  @apply grid grid-cols-2;
  dt {
    @apply font-bold;
  }
}
</style>
